import Link from "next/link";

type PrivacyAcknowledgementProps = {
  className?: string;
};

export function PrivacyAcknowledgement({ className = "" }: PrivacyAcknowledgementProps) {
  return (
    <p className={`text-xs leading-relaxed text-text-muted dark:text-offwhite/55 ${className}`}>
      By submitting this form, you agree that Singing Attitude Ltd may use your details to respond to your enquiry or
      process your booking in accordance with our{" "}
      <Link href="/privacy" className="inline-flex min-h-9 items-center font-semibold text-emerald hover:text-emerald/80">
        Privacy Policy
      </Link>
      .
    </p>
  );
}
